import navbarSearch from '../modules/navbar-search';
import commonAnalytics from '../modules/analytics/common';
let commonController = () => {
    // require('../modules/adblock').on();
    require('../modules/optout')();
    require('../modules/hamburger').on();
    require('../modules/hamburger-sections')();
    require('../modules/admin/hamburger')();
    navbarSearch();
    commonAnalytics();
};

export default commonController;
